export default __webpack_public_path__ + "static/media/Dr._Loubna_Noureddin_In_Moms_We_Trust.ec67190c.jpg";